export default "__VITE_ASSET__762b99c9__"